import { render, staticRenderFns } from "./ComparadorFolioHeaders.vue?vue&type=template&id=1306d0c1"
import script from "./ComparadorFolioHeaders.vue?vue&type=script&lang=js"
export * from "./ComparadorFolioHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports